// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThankYou_container__weLvL {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: #f8f9fa;
}

.ThankYou_card__DjfEj {
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 3rem;
  width: 100%;
  max-width: 500px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.ThankYou_checkmarkContainer__hjhJn {
  width: 120px;
  height: 120px;
  background-color: #fff5f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  border: 1px solid #ffaeae;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.ThankYou_checkmark__6u1A5 {
  width: 60px;
  height: 60px;
  color: #f73439;
  animation: ThankYou_checkmarkAnimation__lu4BT 2s ease-in-out infinite;
}

.ThankYou_checkmarkCircle__qYc0Y {
  stroke: #f73439;
  stroke-width: 2;
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  fill: none;
  animation: ThankYou_stroke__MHxAG 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards, ThankYou_pulse__BTgCQ 2s ease-in-out infinite;
  animation-delay: 0.2s, 1s;
}

.ThankYou_checkmarkCheck__9\\+CzF {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: ThankYou_stroke__MHxAG 0.3s cubic-bezier(0.65, 0, 0.45, 1) forwards, ThankYou_pulse__BTgCQ 2s ease-in-out infinite;
  animation-delay: 0.8s, 1.2s;
}

@keyframes ThankYou_stroke__MHxAG {
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes ThankYou_checkmarkAnimation__lu4BT {
  0% {
    transform: scale(0.9);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(0.9);
    opacity: 0.8;
  }
}

@keyframes ThankYou_pulse__BTgCQ {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.8;
  }
}

.ThankYou_title__okDAC {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.ThankYou_message__\\+M8SP {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
  margin: 0.5rem 0 1.5rem;
}

.ThankYou_logoutButton__9esYe {
  background-image: linear-gradient(45deg, #f73439, #f8777b);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.8rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(247, 52, 57, 0.2);
}

.ThankYou_logoutButton__9esYe:hover {
  background-image: linear-gradient(45deg, #e62d32, #f66569);
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(247, 52, 57, 0.3);
}

.ThankYou_logoutButton__9esYe:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(247, 52, 57, 0.2);
}

@media (max-width: 768px) {
  .ThankYou_card__DjfEj {
    padding: 2rem;
  }
  
  .ThankYou_checkmarkContainer__hjhJn {
    width: 100px;
    height: 100px;
  }
  
  .ThankYou_checkmark__6u1A5 {
    width: 50px;
    height: 50px;
  }
  
  .ThankYou_title__okDAC {
    font-size: 1.75rem;
  }
}

@media (max-width: 480px) {
  .ThankYou_card__DjfEj {
    padding: 1.5rem;
  }
  
  .ThankYou_checkmarkContainer__hjhJn {
    width: 80px;
    height: 80px;
  }
  
  .ThankYou_checkmark__6u1A5 {
    width: 40px;
    height: 40px;
  }
  
  .ThankYou_title__okDAC {
    font-size: 1.5rem;
  }
  
  .ThankYou_message__\\+M8SP {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organism/ThankYou.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qEAAqD;AACvD;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;EACV,6HAA6F;EAC7F,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,6HAA6F;EAC7F,2BAA2B;AAC7B;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0DAA0D;EAC1D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,0DAA0D;EAC1D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 2rem;\n  background-color: #f8f9fa;\n}\n\n.card {\n  background-color: white;\n  border-radius: 16px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  padding: 3rem;\n  width: 100%;\n  max-width: 500px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.checkmarkContainer {\n  width: 120px;\n  height: 120px;\n  background-color: #fff5f5;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1rem;\n  border: 1px solid #ffaeae;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);\n}\n\n.checkmark {\n  width: 60px;\n  height: 60px;\n  color: #f73439;\n  animation: checkmarkAnimation 2s ease-in-out infinite;\n}\n\n.checkmarkCircle {\n  stroke: #f73439;\n  stroke-width: 2;\n  stroke-dasharray: 166;\n  stroke-dashoffset: 166;\n  fill: none;\n  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards, pulse 2s ease-in-out infinite;\n  animation-delay: 0.2s, 1s;\n}\n\n.checkmarkCheck {\n  transform-origin: 50% 50%;\n  stroke-dasharray: 48;\n  stroke-dashoffset: 48;\n  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) forwards, pulse 2s ease-in-out infinite;\n  animation-delay: 0.8s, 1.2s;\n}\n\n@keyframes stroke {\n  100% {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes checkmarkAnimation {\n  0% {\n    transform: scale(0.9);\n    opacity: 0.8;\n  }\n  50% {\n    transform: scale(1.1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(0.9);\n    opacity: 0.8;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0.8;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.8;\n  }\n}\n\n.title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #333;\n  margin: 0;\n}\n\n.message {\n  font-size: 1.1rem;\n  color: #666;\n  line-height: 1.6;\n  margin: 0.5rem 0 1.5rem;\n}\n\n.logoutButton {\n  background-image: linear-gradient(45deg, #f73439, #f8777b);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.8rem 2rem;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 8px rgba(247, 52, 57, 0.2);\n}\n\n.logoutButton:hover {\n  background-image: linear-gradient(45deg, #e62d32, #f66569);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(247, 52, 57, 0.3);\n}\n\n.logoutButton:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 4px rgba(247, 52, 57, 0.2);\n}\n\n@media (max-width: 768px) {\n  .card {\n    padding: 2rem;\n  }\n  \n  .checkmarkContainer {\n    width: 100px;\n    height: 100px;\n  }\n  \n  .checkmark {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .title {\n    font-size: 1.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .card {\n    padding: 1.5rem;\n  }\n  \n  .checkmarkContainer {\n    width: 80px;\n    height: 80px;\n  }\n  \n  .checkmark {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .title {\n    font-size: 1.5rem;\n  }\n  \n  .message {\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ThankYou_container__weLvL`,
	"card": `ThankYou_card__DjfEj`,
	"checkmarkContainer": `ThankYou_checkmarkContainer__hjhJn`,
	"checkmark": `ThankYou_checkmark__6u1A5`,
	"checkmarkAnimation": `ThankYou_checkmarkAnimation__lu4BT`,
	"checkmarkCircle": `ThankYou_checkmarkCircle__qYc0Y`,
	"stroke": `ThankYou_stroke__MHxAG`,
	"pulse": `ThankYou_pulse__BTgCQ`,
	"checkmarkCheck": `ThankYou_checkmarkCheck__9+CzF`,
	"title": `ThankYou_title__okDAC`,
	"message": `ThankYou_message__+M8SP`,
	"logoutButton": `ThankYou_logoutButton__9esYe`
};
export default ___CSS_LOADER_EXPORT___;
